import { render } from "./CustomerAccountQuery.vue?vue&type=template&id=f38b2cd0&scoped=true"
import script from "./CustomerAccountQuery.vue?vue&type=script&lang=js"
export * from "./CustomerAccountQuery.vue?vue&type=script&lang=js"

import "./CustomerAccountQuery.vue?vue&type=style&index=0&id=f38b2cd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f38b2cd0"]])

export default __exports__